import React from 'react';

const ComplianceStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status?.toLowerCase()) {
      case 'compliant':
        return {
          label: 'Compliant',
          bgColor: 'bg-success/10',
          textColor: 'text-success',
          dotColor: 'bg-success'
        };
      case 'warning':
        return {
          label: 'Warning',
          bgColor: 'bg-warning/10',
          textColor: 'text-warning',
          dotColor: 'bg-warning'
        };
      case 'critical':
        return {
          label: 'Critical',
          bgColor: 'bg-error/10',
          textColor: 'text-error',
          dotColor: 'bg-error'
        };
      default:
        return {
          label: 'Unknown',
          bgColor: 'bg-muted',
          textColor: 'text-muted-foreground',
          dotColor: 'bg-muted-foreground'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${config?.bgColor}`}>
      <span className={`w-2 h-2 rounded-full ${config?.dotColor}`}></span>
      <span className={`text-xs md:text-sm font-medium ${config?.textColor}`}>{config?.label}</span>
    </div>
  );
};

export default ComplianceStatusBadge;